export default {"src":"/evde-internet/_next/static/media/headerLogo.4f416b00.svg","height":85,"width":85};